import { Box, Grid } from '@mui/material'
import ApprovalApi, { ApprovalCancelReceipt, ApprovalLinkProps, ApprovalStatus } from 'api/approval/approval.api'
import { swalCustom } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import Loading from 'component/Loading'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import PatientProfileCard from 'component/Treatments/PatientProfileCard'
import PopupManageTreatmentCourse from 'component/Treatments/PopupManageTreatmentCourse'
import { colors } from 'constants/theme'
import AlertModal from 'new-components/modal/alert-modal'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { getBranch, getToken } from 'utils/app.utils'
import { ApprovalSelectorCustom } from '../approvel-list'

const ChangeCost = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const history = useHistory()

    const [load, setLoad] = useState<boolean>(false)
    const [approval, setApproval] = useState<ApprovalStatus>(ApprovalStatus.PENDING)
    const [newApproval, setNewApproval] = useState<ApprovalStatus>(ApprovalStatus.PENDING)
    const [approvalDisabled, setApprovalDisabled] = useState<boolean>(false)
    const [approvalItemId, setApprovalItemId] = useState<number>(0)
    const [dataApproval, setDataApproval] = useState<any>({})

    const [objDataCurrent, setObjDataCurrent] = useState<any>({})
    const [objDataChange, setObjDataChange] = useState<any>({})

    const [outToken, setOutToken] = useState<boolean>(false)
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const [openModal, setOpenModal] = useState(false);
    const [configModal, setConfigModal]: any = useState({ modul: '', title: '', message: '', onSubmit: null })
    const token = getToken()

    const handleSetDataApproval = async (info: any) => {
        setDataApproval(info)
        setApprovalItemId(info?.approvalItemId)
        setApproval(info?.status || ApprovalStatus.PENDING)
        try {
            const newDataCurrent = info?.body ? JSON.parse(info.body) : {}
            newDataCurrent['doctorName'] = (info?.dentistFullname === undefined ? info?.doctorName : info?.dentistFullname) || ''
            setObjDataCurrent({ ...newDataCurrent })
        } catch { setObjDataCurrent({}) }
        try {
            setObjDataChange(info?.newBody ? JSON.parse(info.newBody) : {})
        } catch { setObjDataChange({}) }
        setApprovalDisabled(info?.status === ApprovalStatus.APPROVED ||
            info?.status === ApprovalStatus.REJECT ||
            info?.status === ApprovalStatus.CANCEL)
    }

    const loadChangeCostApproval = async () => {
        if (params.get('id') && typeof params.get('id') === 'string') {
            setLoad(true)
            const token = getToken()
            await ApprovalApi.findApprovalChangeCostWithoutToken(String(params.get('id'))).then(({ data }) => {
                const resData = data
                if (resData?.status === ApprovalStatus.APPROVED || resData?.status === ApprovalStatus.REJECT) {
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.IS_APPROVED_TITLE`),
                        t(`APPROVELLIST.MESSAGE.IS_APPROVED_SUB`),
                        () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                } else if (resData?.status === ApprovalStatus.CANCEL) {
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.ALERT_CANCEL`),
                        t(`APPROVELLIST.MESSAGE.ALERT_CANCEL_SUB`),
                        () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                }
                else {
                    handleSetDataApproval(resData)
                }
            }).finally(() => setLoad(false))
        }
    }

    const loadData = async () => {
        setLoad(true)
        const newLocation: any = location
        if (newLocation?.search && params.get('id')) {
            setOutToken(true)
            loadChangeCostApproval()
            return
        }

        const stateData = newLocation?.state?.objData
        if (stateData?.approvalItemId) {
            try {
                const { data } = await ApprovalApi.findApprovalItemById(stateData.approvalItemId)
                handleSetDataApproval({ ...stateData, ...data })
            } catch {
                handleSetDataApproval(stateData)
            }
        }
        setLoad(false)
    }

    useEffect(() => {
        loadData()
    }, [location])

    const onGoBackApproval = () => {
        history.push(routeName.approvelList)
    }

    const onSubmit = async () => {
        if (approval === 'PENDING' || approvalDisabled) {
            history.push(routeName.approvelList)
            return
        }

        const newPayload: ApprovalCancelReceipt = {
            requestReason: dataApproval?.requestReason,
            requestUserName: dataApproval?.requestUserName,
            requestUserId: dataApproval?.requestUserId,
            approveRemark: dataApproval?.approveRemark,
            refId: dataApproval?.refId,
            branchId: getBranch(),
            status: approval
        }

        if (newPayload) {
            await ApprovalApi.approvalCancelReceipt(approvalItemId, newPayload).then((res) => {
                notiSuccess(t('APPROVAL.MESSAGE.SUC_CREATE'))
                history.push(routeName.approvelList)
            }).catch((e) => {
                const error = e.response?.data?.message
                const errorMessage = ["IS_APPROVED", "IS_CANCEL"]
                if (errorMessage.includes(error)) {
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.${error}_TITLE`),
                        t(`APPROVELLIST.MESSAGE.${error}_SUB`),
                        () => history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                } else {
                    notiError(t('APPROVELLIST.MESSAGE.ERROR'))
                }
            }).finally(() => {
                setLoad(false)
            })
        };
    }


    const onSubmitApproval = async () => {
        if (approval === 'PENDING' || approvalDisabled) {
            history.push(routeName.approvelList)
            return
        } else if (approval === 'APPROVED') {
            setConfigModal({ modul: 'APPROVED', title: 'ยืนยันการเปลี่ยนสถานะ', message: 'คุณต้องการเปลี่ยนสถานะรายการคำขอ รออนุมัติเป็น อนุมัติ ใช่หรือไม่' })
        } else if (approval === 'REJECT') {
            setConfigModal({ modul: 'REJECT', title: 'ไม่อนุมัติคำขอ', message: 'คุณต้องการดำเนินการ "ไม่อนุมัติคำขอนี้"ใช่หรือไม่?' })
        }
        setOpenModal(true)
    }

    const onSubmitOutToken = async () => {
        if (String(params.get('id')) && params?.get('token')) {
            setLoad(true)
            const newPayload: ApprovalLinkProps = {
                approveRemark: '',
                status: approval,
                approveToken: String(params.get('token'))
            }
            await ApprovalApi.approvalLinkOutToken(String(params.get('id')), newPayload).then((res) => {
                swalCustom(
                    t('APPROVELLIST.MESSAGE.IS_APPROVED_SUCCESS_TITLE'),
                    `<div style="width:300px" ></div>`,
                    () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                    'warning',
                    { cancelButton: { showCancelButton: false }, showCloseButton: false }
                )
            }).catch((e) => {
                const error = e.response?.data?.message
                const errorMessage = ["IS_APPROVED", "IS_CANCEL"]
                if (errorMessage.includes(error)) {
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.${error}_TITLE`),
                        t(`APPROVELLIST.MESSAGE.${error}_SUB`),
                        () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                } else {
                    notiError(t('APPROVELLIST.MESSAGE.ERROR'))
                }
            })
                .finally(() => setLoad(false))
        }
    }


    const onSubmitApprovalOutToken = async (status: ApprovalStatus) => {
        setApproval(status)
        if (status === 'PENDING' || approvalDisabled) {
            history.push(routeName.approvelList)
            return
        } else if (status === 'APPROVED') {
            setConfigModal({ modul: 'APPROVED', title: 'ยืนยันการเปลี่ยนสถานะ', message: 'คุณต้องการเปลี่ยนสถานะรายการคำขอ รออนุมัติเป็น อนุมัติ ใช่หรือไม่' })
        } else if (status === 'REJECT') {
            setConfigModal({ modul: 'REJECT', title: 'ไม่อนุมัติคำขอ', message: 'คุณต้องการดำเนินการ "ไม่อนุมัติคำขอนี้"ใช่หรือไม่?' })
        }
        setOpenModal(true)
    }
    return (
        <>
            <Box className={`container-card container-card h-100 overflow-auto`} sx={{ minHeight: '100vh' }}>
                <Loading show={load} />

                <AlertModal
                    isOpen={openModal}
                    handleClose={() => {
                        setOpenModal(false)
                    }}
                    type={configModal.modul === 'REJECT' ? 'error' : 'warning'}
                    title={configModal.title}
                    message={configModal.message}
                    onSubmit={{ onClick: () => outToken ? onSubmitOutToken() : onSubmit(), title: t('BUTTON.SUBMIT') }}
                    onCancel={{
                        onClick: () => {
                            setOpenModal(false)
                        }
                    }}
                />

                <Box className="d-flex flex-column" sx={{ height: '100%' }}>
                    {!outToken &&
                        <HeaderLabel
                            text={t('APPROVELLIST.CHANGE_COST.TITLE')}
                            componentBtnCustom={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: ' 16px' }}>
                                    <Box>
                                        <ApprovalSelectorCustom
                                            approval={approval}
                                            onChange={setApproval}
                                            disabled={approvalDisabled}
                                        />
                                    </Box>
                                    <Box sx={{ width: '100px', button: { width: '100%', padding: '6px 16px', filter: 'grayscale(100%) sepia(0%) brightness(35%) contrast(120%)' } }}>
                                        <ButtonCustom
                                            variant={"outlined"}
                                            textButton={t("BUTTON.CANCEL")}
                                            onClick={onGoBackApproval}
                                        />
                                    </Box>
                                    <Box sx={{ width: '100px', button: { width: '100%', padding: '6px 16px', } }}>
                                        <ButtonCustom
                                            // disabled={disabledSave}
                                            textButton={t("BUTTON.SAVE")}
                                            onClick={onSubmitApproval}
                                        />
                                    </Box>
                                </Box>
                            }
                        />
                    }
                    {outToken &&
                        <Box sx={{ fontSize: '48px', fontWeight: '600', margin: '24px 0 16px 0', textAlign: 'center' }}>
                            {t('APPROVELLIST.TITLE_OUTTOKEN_CHANGECOST')}
                        </Box>
                    }
                    {dataApproval?.patientInfo && (
                        <Box sx={{ margin: !outToken ? '16px 24px 0' : '0 48px 16px' }}>
                            <PatientProfileCard patient={dataApproval.patientInfo} type="historyTreatment" />
                        </Box>
                    )}
                    <Box className="card" sx={{ height: '100%', overflow: 'hidden' }} style={{ maxHeight: '100%', margin: !outToken ? '16px 0 0' : '0 24px 24px' }}>
                        <Box className="overflow-hidden p-4 h-100">
                            <Box className="custom-scroll" sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0 }} style={{ overflowY: !outToken ? 'auto' : 'hidden', overflowX: 'hidden', position: 'relative' }}>
                                <Grid container sx={{ pt: '8px' }} style={!outToken ? {} : { overflow: 'auto', height: 'calc(100% - 140px)' }}>
                                    <Grid item xl={6} lg={6} xs={12} style={{ borderRight: `1px solid ${colors.lightGray}` }}>
                                        <Box>
                                            <Box className={`mb-0`} sx={{ fontSize: '24px', fontWeight: '500' }}>
                                                {t('APPROVELLIST.CHANGE_COST.TITLE_OLD')}
                                            </Box>
                                            <Box sx={{ padding: '24px 32px' }}>
                                                <Box sx={{ marginBottom: '24px', fontSize: '20px', fontWeight: '500', color: colors.themeMainColor, textAlign: 'center' }}>
                                                    {t('APPROVELLIST.CHANGE_COST.TITLE')}
                                                </Box>
                                                {(objDataCurrent?.operativeId && (objDataCurrent?.doctorId || objDataChange?.doctorId)) ?
                                                    <Box>
                                                        <PopupManageTreatmentCourse
                                                            userId={objDataCurrent?.doctorId || objDataChange?.doctorId}
                                                            itemId={0}
                                                            operative={objDataCurrent}
                                                            onSubmit={() => null}
                                                            onReset={() => null}
                                                            noModal
                                                            branchId={dataApproval?.branchId}
                                                        />
                                                    </Box>
                                                    :
                                                    <Box sx={{ textAlign: 'center', color: colors.disabledGray, padding: '32px 0' }}>
                                                        ไม่มีข้อมูล
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xl={6} lg={6} xs={12}>
                                        <Box>
                                            <Box className={`mb-0`} sx={{ fontSize: '24px', fontWeight: '500' }}>
                                                {t('APPROVELLIST.CHANGE_COST.TITLE_NEW')}
                                            </Box>
                                            <Box sx={{ padding: '24px 32px' }}>
                                                <Box sx={{ marginBottom: '24px', fontSize: '20px', fontWeight: '500', color: colors.themeMainColor, textAlign: 'center' }}>
                                                    {t('APPROVELLIST.CHANGE_COST.TITLE')}
                                                </Box>
                                                {(objDataChange?.operativeId && (objDataChange?.doctorId || objDataCurrent?.doctorId)) ?
                                                    <Box>
                                                        <PopupManageTreatmentCourse
                                                            key={`change-cost-new-${objDataChange?.operativeId}-${objDataChange?.promotion?.[0]?.promotionBranchId || 'no-promotion'}`}
                                                            userId={objDataChange?.doctorId || objDataCurrent?.doctorId}
                                                            itemId={0}
                                                            operative={objDataChange}
                                                            onSubmit={() => null}
                                                            onReset={() => null}
                                                            noModal
                                                            branchId={dataApproval?.branchId}
                                                        />
                                                    </Box>
                                                    :
                                                    <Box sx={{ textAlign: 'center', color: colors.disabledGray, padding: '32px 0' }}>
                                                        ไม่มีข้อมูล
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                                {outToken &&
                                    <Box sx={{
                                        marginTop: '24px',
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: '12px',
                                        width: '100%'
                                    }}>
                                        <Box sx={{ width: '100px' }}>
                                            <ButtonCustom
                                                textButton={t('APPROVELLIST.FILTER.REJECT')}
                                                variant={"outlined"}
                                                mode={'del'}
                                                btnStyle={{ width: "100%" }}
                                                onClick={() => onSubmitApprovalOutToken(ApprovalStatus.REJECT)}
                                            />
                                        </Box>
                                        <Box sx={{ width: '100px' }}>
                                            <ButtonCustom
                                                textButton={t('APPROVELLIST.FILTER.APPROVED')}
                                                btnStyle={{ width: "100%" }}
                                                onClick={() => onSubmitApprovalOutToken(ApprovalStatus.APPROVED)}
                                            />
                                        </Box>
                                    </Box>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box >
        </>
    )
}

export default ChangeCost